import { render, staticRenderFns } from "./card-tasks.vue?vue&type=template&id=e9ae06c4&scoped=true"
import script from "./card-tasks.vue?vue&type=script&lang=js"
export * from "./card-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ae06c4",
  null
  
)

export default component.exports